import { createTheme, alpha } from "@mui/material/styles";
import type { Theme } from "@mui/material/styles";
import { theme as legacyTheme } from "./legacyTheme";
import { getSaasPalette, type ColorScheme } from "./saasPalette";

export function buildSaasMuiTheme(scheme: ColorScheme) {
  const saas = getSaasPalette(scheme);
  const isDark = scheme === "dark";

  return createTheme(legacyTheme, {
    palette: {
      mode: isDark ? "dark" : "light",
      saas,
      primary: { main: isDark ? saas.accentBlue : "#1565c0" },
      secondary: { main: isDark ? saas.accentPurple : "#3DDC97" },
      background: {
        default: saas.pageBg,
        paper: saas.surface,
      },
      text: {
        primary: saas.textPrimary,
        secondary: saas.textMuted,
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          html: {
            backgroundColor: saas.pageBg,
          },
          body: {
            backgroundColor: saas.pageBg,
          },
          "#root": {
            backgroundColor: saas.pageBg,
            minHeight: "100%",
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: ({ theme }: { theme: Theme }) => ({
            backgroundImage: "none",
            backgroundColor: theme.palette.saas.surface,
          }),
        },
      },
      MuiChip: {
        styleOverrides: {
          outlined: ({ theme }: { theme: Theme }) =>
            theme.palette.mode === "light"
              ? {
                  "&.MuiChip-colorWarning": {
                    color: theme.palette.warning.dark,
                    borderColor: alpha(theme.palette.warning.main, 0.45),
                    "& .MuiChip-icon": { color: theme.palette.warning.dark },
                  },
                  "&.MuiChip-colorSuccess": {
                    color: theme.palette.success.dark,
                    borderColor: alpha(theme.palette.success.main, 0.45),
                    "& .MuiChip-icon": { color: theme.palette.success.dark },
                  },
                  "&.MuiChip-colorError": {
                    color: theme.palette.error.dark,
                    borderColor: alpha(theme.palette.error.main, 0.45),
                    "& .MuiChip-icon": { color: theme.palette.error.dark },
                  },
                  "&.MuiChip-colorInfo": {
                    color: theme.palette.info.dark,
                    borderColor: alpha(theme.palette.info.main, 0.45),
                    "& .MuiChip-icon": { color: theme.palette.info.dark },
                  },
                }
              : {},
        },
      },
    },
  });
}
